import { Component, Input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ATSJobIntegration } from '@app/models/company/ats-job-integration.model';
import { SettingsIntegration } from '@app/models/company/settings/settings-integration.model';
import { Question } from '@app/models/recruiting/question.model';
import { getFullLocationFromAddress } from '@app/modules/applicant-tracker/functions/get-full-location-from-address.function';
import { JobPostingOptionalField } from '@app/modules/applicant-tracker/interfaces/optional-field.interface';
import { ApplicantOptionalFieldService } from '@app/modules/applicant-tracker/services';
import { ActiveIntegrations } from '@app/modules/settings/enums/integration.enum';
import { SettingsIntegrationService } from '@app/modules/settings/services';
import { FeatureService } from '@app/services/feature.service';
import { EmploymentTypeDisplayOptions } from '@app/types/translatables/employment-type-display.options';
import { BaseForm } from '@forms/base.form';
import { JobAttachment } from '@models/recruiting/job-attachments.model';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { from } from 'rxjs';

@Component({
    selector: 'app-job-posting-store-review-information',
    templateUrl: './job-posting-store-review.form.html',
    styleUrls: ['./job-posting-store-review.style.scss'],
})
export class JobPostingStoreReviewForm extends BaseForm implements OnInit {
    @Input() jobPosting: JobPosting;
    @Input() jobIntegrations: ATSJobIntegration[] = [];
    @Input() jobAttachments: JobAttachment[] = [];
    @Input() additionalQuestions: Question[] = [];
    @Input() autoArchivingQuestions: Question[] = [];

    integrations: SettingsIntegration[] = [];
    fields: JobPostingOptionalField[] = [];

    jobPostingFullLocation = '';

    employmentTypesDisplay = EmploymentTypeDisplayOptions;
    activeIntegrations = ActiveIntegrations;

    showIntegrationWarning = false;

    integrationImages: { [key: string]: string } = {};

    isIndeedDisabled = toSignal(from(this.featureService.has('disable-indeed-integration')));

    constructor(
        private integrationService: SettingsIntegrationService,
        public applicantOptionalFieldService: ApplicantOptionalFieldService,
        private featureService: FeatureService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.integrations = await this.integrationService.getCompanyActiveIntegrations();

        if (this.jobPosting.isActive) {
            this.initiallyLoadATSJobIntegrations();
        }

        this.showIntegrationWarning = Boolean(!this.jobPosting.isActive && this.integrations.length);
    }

    refreshAddressForLinkComponent(): void {
        const address = this.jobPosting.address;
        this.jobPostingFullLocation = getFullLocationFromAddress(address);
    }

    initiallyLoadATSJobIntegrations(): void {
        this.integrations.forEach((integration: SettingsIntegration) => {
            const jobIntegration = new ATSJobIntegration({
                integrationId: integration.id,
                isEnabled: true,
            });

            jobIntegration.integrationType = integration;

            this.jobIntegrations.push(jobIntegration);

            this.integrationImages[integration.integrationType.name] =
                `${integration.integrationType.assetBaseURL}${integration.integrationType.name}.svg`;
        });
    }

    onToggleChange(state: boolean, integration: SettingsIntegration): void {
        let jobIntegration = this.jobIntegrations.find((item: ATSJobIntegration) => {
            return item.integrationId === integration.id;
        });

        if (!state) {
            const index = this.jobIntegrations.findIndex((item: ATSJobIntegration) => {
                return item.integrationId === integration.id;
            });
            // Used splice since we want to keep the reference of the object.
            this.jobIntegrations.splice(index, 1);

            return;
        }

        if (jobIntegration) {
            jobIntegration.isEnabled = state;
        } else {
            jobIntegration = new ATSJobIntegration({
                integrationId: integration.id,
                isEnabled: state,
            });

            jobIntegration.integrationType = integration;

            this.jobIntegrations.push(jobIntegration);
        }
    }
}
